import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { sizes } from '../utils/breakpoints'
import theme from '../theme'
import InfoCardComponent from './InfoCardComponent'
import { useMediaQuery } from 'react-responsive'
import teamPhoto from '../assets/images/equipo-tartis.jpg'
import teamPhotoMobile from '../assets/images/equipo-tartis.jpg'

const CodeIcon = () => (
  <svg width="56" height="56" viewBox="0 0 24 24" fill="none">
    <path
      d="M9 8l-4 4 4 4M15 8l4 4-4 4"
      stroke={theme.colors.brand.green}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const CloudIcon = () => (
  <svg width="56" height="56" viewBox="0 0 24 24" fill="none">
    <path
      d="M6.5 19a4 4 0 01-.6-7.95 5.5 5.5 0 0110.9-1.55A4.5 4.5 0 0117.5 19h-11z"
      stroke={theme.colors.brand.dark}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const InfoCardListComponent = () => {
  const isMobile = useMediaQuery({ maxWidth: sizes.mobile })
  const { t } = useTranslation()

  const options = [
    {
      text: t('sobreNosotros.cards.team.text'),
      photo: isMobile ? teamPhotoMobile : teamPhoto,
      photoAlt: t('sobreNosotros.cards.team.photoAlt'),
      isRigth: true,
      isLeft: false,
      max: '460px',
    },
    {
      text: t('sobreNosotros.cards.software.text'),
      textBold: t('sobreNosotros.cards.software.textBold'),
      panel: (
        <IconPanel $bg={theme.colors.brand.dark}>
          <CodeIcon />
        </IconPanel>
      ),
      isRigth: false,
      isLeft: true,
      max: '520px',
    },
    {
      text: t('sobreNosotros.cards.cloud.text'),
      panel: (
        <IconPanel $bg={theme.colors.brand.green}>
          <CloudIcon />
        </IconPanel>
      ),
      isRigth: true,
      isLeft: false,
      max: '400px',
    },
  ]

  return (
    <Container>
      {options.map((op, idx) => (
        <InfoCardComponent
          key={idx}
          info={op.text}
          infoBold={op.textBold}
          isRight={op.isRigth}
          isLeft={op.isLeft}
          photo={op.photo}
          photoAlt={op.photoAlt}
          panel={op.panel}
          max={op.max}
        />
      ))}
      <ClosingBand>
        <ClosingLabel>{t('sobreNosotros.closing.label')}</ClosingLabel>
        <ClosingText>{t('sobreNosotros.closing.text')}</ClosingText>
      </ClosingBand>
    </Container>
  )
}

export default InfoCardListComponent

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

const IconPanel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ $bg }) => $bg};
`

const ClosingBand = styled.div`
  align-self: stretch;
  width: 100vw;
  margin: 8px 0 0 calc(-50vw + 50%);
  background-color: ${({ theme }) => theme.colors.brand.dark};
  padding: 56px 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${sizes.mobile}px) {
    padding: 36px 24px;
  }
`

const ClosingLabel = styled.p`
  font-family: ${({ theme }) => theme.fonts.accentBold};
  font-size: 13px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.brand.green};
  margin: 0 0 16px;
`

const ClosingText = styled.p`
  max-width: 720px;
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.accentRegular};
  font-style: italic;
  font-weight: 400;
  font-size: 26px;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.text.onDark};
  margin: 0;

  @media (max-width: ${sizes.mobile}px) {
    font-size: 18px;
  }
`
